var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCircleCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6997 2.33416C10.5797 -0.778055 5.45987 -0.778055 2.33994 2.33416C-0.779981 5.44638 -0.779981 10.5536 2.33994 13.6658C5.45987 16.7781 10.4997 16.7781 13.6197 13.6658C16.7396 10.5536 16.8196 5.44638 13.6997 2.33416ZM11.2598 12.3516L8.01981 9.11721L4.77986 12.3516L3.65989 11.2344L6.89983 8L3.65989 4.76559L4.77986 3.64838L8.01981 6.88279L11.2598 3.64838L12.3797 4.76559L9.13978 8L12.3797 11.2344L11.2598 12.3516Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCancel);
export default __webpack_public_path__ + "static/media/icon--circle-cancel.288b36d340e96fb74897bad6c40cadc8.svg";
export { ForwardRef as ReactComponent };